export const isLocalOrStubs = (): boolean => {
    return process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === 'stubs';
};
